<script>
import { focoRoutingSteps } from '@/modules/Management/focoRoutingSteps'

export default {
  name: 'FocoRoutingSection',
  components: {
    FormSection: () => import('@/components/general/FormSection'),
    RadioItem: () => import('@/components/general/RadioItem')
  },

  props: {
    value: {
      type: Number,
      required: true
    },

    savedStep: {
      type: Number,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    steps () {
      return focoRoutingSteps.map(item => ({
        step: item.step,
        label: this.$t(item.label),
        effect: this.$t(item.effect)
      }))
    }
  },

  methods: {
    isChecked (step) {
      return step === this.value
    },

    isSaved (step) {
      return step === this.savedStep
    },

    select (step) {
      if (this.disabled) {
        return
      }

      this.$emit('input', step)
    }
  }
}
</script>

<template>
  <div class="foco-routing">
    <FormSection :title="$t('management.general:field.name.foco.user_integration')">
      <p class="foco-routing__description">
        {{ $t('management.general:foco.routing.description') }}
      </p>

      <ul class="foco-routing__list">
        <li
          v-for="(item, index) in steps"
          :key="item.step"
          class="foco-routing-step"
          :class="{
            'is-selected': isChecked(item.step),
            'is-disabled': disabled
          }"
          @click="select(item.step)"
        >
          <div class="foco-routing-step__control">
            <RadioItem
              :label="item.label"
              :value="item.step"
              :index="index"
              :name="_uid"
              :checked="isChecked(item.step)"
              :disabled="disabled"
              @change="select"
            />

            <span
              v-if="isSaved(item.step)"
              class="foco-routing-step__badge"
            >
              {{ $t('management.general:foco.routing.badge.saved') }}
            </span>
          </div>

          <p class="foco-routing-step__effect">
            {{ item.effect }}
          </p>
        </li>
      </ul>
    </FormSection>
  </div>
</template>

<style src="@/assets/styles/themes/default/radio.css"></style>

<style lang="scss" scoped>
.foco-routing {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.foco-routing__description {
  font-size: 1.4em;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.6);
  margin: -8px 0 20px;
}

.foco-routing__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.foco-routing-step {
  padding: 16px 20px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.foco-routing-step + .foco-routing-step {
  margin-top: 12px;
}

.foco-routing-step:hover {
  border-color: rgba(0, 94, 184, 0.5);
}

.foco-routing-step.is-selected {
  border-color: #005EB8;
  box-shadow: inset 0 0 0 1px #005EB8;
}

.foco-routing-step.is-disabled {
  cursor: default;
  background-color: rgba(0, 0, 0, 0.02);
}

.foco-routing-step.is-disabled:hover {
  border-color: rgba(0, 0, 0, 0.12);
}

.foco-routing-step__control {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.foco-routing-step__control ::v-deep .form-radio-item {
  overflow: visible;
}

.foco-routing-step__control ::v-deep .form-radio-label {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.foco-routing-step__badge {
  padding: 3px 12px;
  font-size: 1.2em;
  font-weight: 600;
  line-height: 1.6;
  color: #005EB8;
  background-color: rgba(0, 94, 184, 0.1);
  border-radius: 12px;
  white-space: nowrap;
}

.foco-routing-step__effect {
  margin: 6px 0 0 30px;
  font-size: 1.4em;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 767px) {
  .foco-routing-step {
    padding: 14px 16px;
  }

  .foco-routing-step__effect {
    margin-left: 0;
  }
}
</style>
